export const getPathToMessages = (translationsStaticUrl, languageCode) => `${translationsStaticUrl}assets/locale/messages_${languageCode || 'en'}.json`;
//# sourceMappingURL=getPathToMessages.js.map